import Vue from 'vue'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueLocalstorage from 'vue-localstorage'
Vue.use(VueLocalstorage)

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

export default {}
